var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "showSubscriptionModal",
    attrs: {
      id: "show-subscription-modal",
      "modal-dialog-size": "lg",
      "loaders-disabled": "",
      "modal-dialog-scrollable": false,
    },
    on: { show: _vm.handleShow },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("application.applicationHeader.emailsSubscriptions")
                  ) +
                  "\n      "
              ),
              _c("div", [
                _c("h6", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "application.applicationHeader.hereIsTheSubscriptionInformation"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("showSubscription-loader")
              : [
                  _vm.emailsToShow.length
                    ? _c("v-client-table", {
                        staticClass: "vue-custom-table no-pagination",
                        attrs: {
                          data: _vm.emailsToShow,
                          columns: _vm.table.columns,
                          options: _vm.table.options,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "h__email",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "text-uppercase" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$tc("global.words.email", 1)
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "h__subscribed",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "text-uppercase" },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            _vm.$t("global.words.subscribed")
                                          ) +
                                          "\n          "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("icon", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip",
                                        value: {
                                          title: _vm.$t(
                                            "application.applicationHeader.subscribedTooltip"
                                          ),
                                        },
                                        expression:
                                          "{\n              title: $t('application.applicationHeader.subscribedTooltip')\n            }",
                                      },
                                    ],
                                    staticClass: "ml-1",
                                    attrs: { name: "info-circle" },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "email",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.email) +
                                      "\n        "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "subscribed",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("icon", {
                                    staticClass: "fa-lg",
                                    class:
                                      row.global || row.agent
                                        ? "text-danger"
                                        : "text-success",
                                    attrs: {
                                      name:
                                        row.global || row.agent
                                          ? "times"
                                          : "check",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          923385286
                        ),
                      })
                    : _c(
                        "no-results",
                        {
                          attrs: {
                            "img-src": require("@Shared/@Assets/img/application-missing.png"),
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "application.applicationHeader.thereAreNoEmailsToShow"
                                )
                              ) +
                              "\n      "
                          ),
                        ]
                      ),
                ],
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }